import React from "react";

export default function CopyRight() {
  return (
    <div className="sm:border-r border-r-0">
      <p className="font-normal text-xs md:text-sm pr-4">
        &copy; Society of plastic surgeons of Bangladesh 2024.
      </p>
    </div>
  );
}
